import { Box, Tooltip } from '@mui/material'
import { useLingui } from '@lingui/react'
import { msg } from '@lingui/macro'
import useOnlineStatus from '../hooks/useOnlineStatus'

/**
 * Pallino nello header: verde se online, rosso se offline (con tooltip).
 */
export default function OnlineStatusIndicator() {
  const isOnline = useOnlineStatus()
  const { _ } = useLingui()

  const label = isOnline ? _(msg`Online`) : _(msg`Offline`)

  return (
    <Tooltip title={label} arrow enterTouchDelay={300}>
      <Box
        component="span"
        role="status"
        aria-label={label}
        sx={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          flexShrink: 0,
          display: 'inline-block',
          bgcolor: isOnline ? '#90EE90' : 'error.main',
          boxShadow: theme =>
            isOnline
              ? `0 0 0 2px ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.45)'}`
              : `0 0 0 2px ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.12)'}`
        }}
      />
    </Tooltip>
  )
}
